import * as React from 'react';
import styled from 'styled-components';

interface StyleProps {
  shape: string;
}
const Wrap = styled.div<StyleProps>`
  position: absolute;
  ${props => props.shape === 'top' ? 
  ('top: 0; right: 0; width: 232px;') : 
  ('bottom: -55px; left: 0; width: 313px;')}
  & img {
    width: 100%;
  }
  @media (max-width: 375px) {
    @media (max-width: 320px) {
      ${props => props.shape === 'top' ? 
      ('width: 182px;') : 
      ('bottom: -45px; width: 253px;')}
    }

    @media (max-height: 600px) {
      ${props => props.shape === 'top' ? 
      ('width: 182px;') : 
      ('bottom: -45px; width: 200px;')}
    }
  }
`;

interface IProps {
  shape: string;
}

const Flower = ({shape}: IProps) => {
  return (
    <Wrap shape={shape}>
      <img src={require(shape === 'top' ? "../../assets/intro/flower_top@2x.png" : "../../assets/intro/flower_bottom@2x.png")} alt="flower" />
    </Wrap>
  );
};

export default Flower;



// WEBPACK FOOTER //
// ./src/components/intro/flower.tsx